import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

const taskTagActions = getActionTypes('taskTag', [
    'GET_ALL',
    'GET',
    'CREATE',
    'UPDATE',
    'DELETE'
]);

export const taskActions = getActionTypes('task', [
    'GET_ALL',
    'GET',
    'CREATE',
    'UPDATE',
    'DELETE',
    'COPY',
]);

export const actions = {
    ...taskTagActions,
    ...taskActions
}

export const initialTaskState = {
    ...generateDefaultState('taskTag', [
        'GET_ALL',
        'GET',
        'CREATE',
        'UPDATE',
        'DELETE'
    ]),
    ...generateDefaultState('task', [
        'GET_ALL',
        'GET',
        'CREATE',
        'UPDATE',
        'DELETE',
        'COPY'
    ]),
};
